/**
 * SettingsTabContent — Lazy-loaded wrapper for the chat settings tab, used
 * by the unified user-settings page (reached via top-right avatar → Settings).
 *
 * Preserves code-splitting so the settings panel is not pulled into the main
 * chunk on initial load.
 */

import { PageSkeleton } from "@plerity/dashboard-shared/components";
import { lazy, Suspense } from "react";

const ChatSettings = lazy(() => import("../chat/ChatSettings"));

function TabShell({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<PageSkeleton />}>{children}</Suspense>;
}

export function ChatSettingsTabContent() {
  return (
    <TabShell>
      <ChatSettings />
    </TabShell>
  );
}
